import React, { useState, useEffect } from "react";
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import HeaderTitle from "../../dashboard/HeaderTitle";
import { Base_URL } from "../../../apiConfig";
import { useSelector } from "react-redux"; // Import useSelector

const AddScholarship = () => {
  const [formData, setFormData] = useState({
    university_id: null,
    scholarship_desc: "",
  });

  const [universities, setUniversities] = useState([]);
  const [loading, setLoading] = useState(false);

  // Retrieve token from Redux store
  const { token } = useSelector((state) => state.auth);

  useEffect(() => {
    const fetchUniversities = async () => {
      try {
        const response = await axios.get(`${Base_URL}/universities`);
        const universityOptions = response.data.map((uni) => ({
          value: uni.university_id,
          label: uni.university_name,
        }));
        setUniversities(universityOptions);
      } catch (error) {
        console.error("Failed to fetch universities:", error);
        toast.error("Failed to fetch universities.");
      }
    };

    fetchUniversities();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!formData.university_id || !formData.scholarship_desc) {
      toast.error("Please fill in all the fields.");
      setLoading(false);
      return;
    }

    try {
      await axios.post(`${Base_URL}/create/scholarship`, formData, {
        headers: {
          "Content-Type": "application/json",
          "authorization": `Bearer ${token}`, // Add token to authorization header
        },
        withCredentials: true // Enable withCredentials
      });

      toast.success("Scholarship added successfully!");
      setFormData({ university_id: null, scholarship_desc: "" });
    } catch (error) {
      console.error("Error adding scholarship:", error.response?.data || error.message);
      toast.error("Failed to add scholarship. Please try again.");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="bg-gray-100 p-6">
        <HeaderTitle mainTitle="Scholarship" subTitle="Add Scholarship" />
        <div className="bg-white p-4 rounded-md">
          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* Select University */}
              <div className="flex flex-col">
                <label htmlFor="university_id" className="mb-2 font-medium text-sm">
                  Select University
                </label>
                {loading ? (
                  <p>Loading universities...</p>
                ) : (
                  <Select
                    id="university_id"
                    value={universities.find((uni) => uni.value === formData.university_id)}
                    onChange={(selectedOption) => setFormData({ ...formData, university_id: selectedOption.value })}
                    options={universities}
                    placeholder="Select University"
                    className="basic-single"
                    classNamePrefix="select"
                    isClearable
                  />
                )}
              </div>

              {/* Scholarship Description with CKEditor */}
              <div className="flex flex-col md:col-span-2">
                <label htmlFor="scholarship_desc" className="mb-2 font-medium text-sm">
                  Scholarship Description
                </label>
                <CKEditor
                  editor={ClassicEditor}
                  data={formData.scholarship_desc}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    setFormData((prev) => ({ ...prev, scholarship_desc: data }));
                  }}
                />
              </div>
            </div>

            <button type="submit" className="mt-4 px-4 py-2 bg-cmsgreen text-white rounded text-sm hover:bg-hovergreen">
              {loading ? (
                <div className="flex justify-center items-center">
                  <svg
                    className="animate-spin h-5 w-5 text-white mr-3"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                    ></path>
                  </svg>
                  Submitting...
                </div>
              ) : (
                'Submit'
              )}
            </button>
          </form>

          <ToastContainer />
        </div>
      </div>
    </>
  );
};

export default AddScholarship;
